export default __webpack_public_path__ + "static/media/store_svg5.349f0bcd.svg";